module.exports = __webpack_public_path__ + "img/badge-list-thumb-101.5ab9cf72.png";